import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
//import thunkMiddleware from "redux-thunk";
import rootReducer from "../reducers";
import rootSaga from "../sagas";

//const loggerMiddleware = createLogger();
const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  rootReducer,
  applyMiddleware(
    //loggerMiddleware,
    sagaMiddleware
    // thunkMiddleware,
  )
);
sagaMiddleware.run(rootSaga);
